<template>
    <div id="header">
        <modalContact ref="contact"/>
        <div id="logo">
            <router-link :to="$translationRoute({ name: 'home' })">
              <img src='~@/assets/img/logo-white-horizontal.svg' title="narative">
            </router-link>
        </div>
        <div id="auth" v-if="auth">
            <div class="dropdown">
              <img class="avatar" :src="avatarUrl()" title="avatar">
              <div class="content">
                <div @click="avatar">
                  {{ $t('nav.avatar') }}
                  <input type="file" accept="image/jpeg,image/png" ref="avatar" @change="onAvatarChange"/>
                </div>
                <div @click="contact">{{ $t('nav.contact') }}</div>
                <div @click="logout">{{ $t('nav.logout') }}</div>
              </div>
            </div>
        </div>
        <div id="custom">
          <slot/>
        </div>
    </div>
</template>

<script>
import auth from '@/services/auth'
import consts from '@/consts'
import logger from '@/services/logger'
import user from '@/services/user'
import { wsApp } from '@/services/ws'

export default {
  props: {
    auth: Boolean
  },
  data () {
    return {
      avatarCounter: null
    }
  },
  beforeMount () {
    if (!auth) return
    wsApp.on(this.$parent, consts.eventNames.fileAvailable, this.onFileAvailable)
  },
  methods: {
    contact () {
      this.$refs.contact.show()
    },
    avatar () {
      this.$refs['avatar'].click()
    },
    logout () {
      auth._logout(true, true)
    },
    avatarUrl () {
      if (!auth.logged() || !auth.user.avatar_url) return ''
      var u = auth.user.avatar_url
      if (this.avatarCounter) u += '?' + this.avatarCounter
      return u
    },
    onAvatarChange (e) {
      // No file
      if (e.target.files.length === 0) return

      // Get first file
      const f = e.target.files[0]

      // Simulate click on dropdown
      this.$el.querySelector('.dropdown').click()

      // Show loader
      this.$parent.$parent.$parent.$refs.loader.show()

      // Upload file
      user.uploadFile(f, 'Avatar', 'avatar')
        .catch(err => {
          // Hide loader
          this.$parent.$parent.$parent.$refs.loader.hide()

          // Process error
          var msg = this.$i18n.t('errors.default')
          if (err.isHTTP) {
            // Update message
            msg = err
          } else if (err.msg) {
            msg = this.$i18n.t(err.msg)
          } else {
            // Log
            logger.error(err)
          }

          // Toast
          if (!err.noToast) this.$parent.$parent.$parent.$refs.toaster.error(msg)
        })
    },
    onFileAvailable (payload) {
      // Invalid category
      if (payload.category !== 'avatar') return

      // Hide loader
      this.$parent.$parent.$parent.$refs.loader.hide()

      // Increment avatar counter
      if (!this.avatarCounter) this.avatarCounter = 1
      else this.avatarCounter++
    }
  }
}
</script>

<style scoped>

#header {
    background-color: #000000;
    display: table;
    height: 6.5%;
    padding: 0 1.5em;
    position: relative;
    width: 100%;
}

#header > div {
    display: table-cell;
    height: 100%;
    vertical-align: middle;
}

#header a {
  cursor: pointer;
  display: inline-block;
}

#header img {
    height: 2em;
    vertical-align: middle;
}

#header #auth {
  text-align: right;
}

#header #auth .dropdown {
  display: inline-block;
}

#header #auth .avatar {
  cursor: pointer;
}

#header #auth .content {
  margin: auto;
}

#header #auth .content input[type="file"] {
  display: none;
}

#header #custom {
  height: 100%;
  left: 25%;
  position: absolute;
  text-align: center;
  top: 0;
  width: 50%;
}

</style>

<style>

.template > .content {
    height: 93.5%;
}

</style>
